const ERROR_MESSAGE = {
  BAD_REQUEST: {
    TITLE: "不正な要求です",
    MESSAGE: "要求の形式が正しくありません。",
  },
  UNAUTHORIZED: {
    TITLE: "認証が必要です",
    MESSAGE: "セッションの有効期限が切れました。再度ログインしてください。",
  },
  UNAUTHORIZED_PAGE: {
    TITLE: "アクセス権限がありません（401）",
    MESSAGE: "再度ログインしてください。",
  },
  NOT_FOUND: {
    TITLE: "データが見つかりません",
    MESSAGE: "問い合わせが間違っているか、データが削除されました",
  },
  FORBIDDEN: {
    TITLE: "アクセス権限がありません",
    MESSAGE: "再度ログインしてください。",
  },
  SERVER_ERROR: {
    TITLE: "サーバーエラー",
    MESSAGE: "サーバーエラーが発生しました。",
  },
  GATEWAY_TIMEOUT: {
    TITLE: "処理がタイムアウトしました",
    MESSAGE: "時間内に応答がありませんでした。もう一度お試しください。",
  },
  DEFAULT: {
    TITLE: "システムエラーです",
    MESSAGE: "予期せぬエラーが発生しました。",
  },
};

export default ERROR_MESSAGE;
